<template>
  <div style="padding:10px; background:white; width:300px;">
    <div style="width:100%;">
      <Search
        ref="search"
        dbref="SPD.SelPegawaiList"
        width="calc(100% - 30px)"
        @change="AddPegawai"
      />
      <List :items="pegawai" height="200px">
        <template v-slot="{ row, idx }">
          <div style="display:flex; width:calc(100% - 30px); padding: 8px 0;">
            <v-icon :color="colors[idx]" small>mdi-circle</v-icon>
            <div style="margin-left:8px; font-size: 14px">{{ row.Nama }}</div>
            <v-spacer />
            <v-icon color="error" small @click="Remove(idx)">mdi-close</v-icon>
          </div>
        </template>
      </List>
      <hr />
      <List dbref="SPD.SelTerbanyak" :dbparams="{ NIPS }">
        <template v-slot="{ row }">
          <div style="display:flex; width:calc(100% - 30px); padding: 8px 0;">
            <!-- <div style="margin-left:8px; font-size: 14px">{{ row.Nama }}</div> -->
            <v-btn
              text
              small
              style="max-width:85%; justify-content: flex-start; overflow:hidden"
              @click="OpenDetail(row)"
              >{{ row.Nama }}</v-btn
            >
            <v-spacer />
            <div style="padding:5px 0; font-size: small;">
              {{ row.JmlHari }} hr
            </div>
          </div>
        </template>
      </List>
    </div>
    <ListSPPD :nip="NIP" :nama="Nama" :show.sync="showDetail" />
  </div>
</template>
<script>
import ListSPPD from './ListSPPD.vue'
export default {
  components: { ListSPPD },
  data: () => ({
    pegawai: [],
    showDetail: false,
    NIP: '',
    Nama: '',
    colors: [
      'blue',
      'indigo',
      'green',
      'deep-purple',
      'cyan',
      'orange',
      'grey darken-1',
    ],
  }),
  computed: {
    NIPS() {
      return this.pegawai.map(p => p.NIP).join(',')
    },
  },
  methods: {
    OpenDetail(row) {
      this.NIP = row.NIP
      this.Nama = row.Nama
      this.showDetail = true
    },
    AddPegawai(val) {
      if (this.pegawai.length < this.colors.length) {
        this.pegawai.push(val)
        this.$refs.search.Clear()

        this.$emit('change', this.pegawai)
      }
    },
    Remove(idx) {
      this.pegawai.splice(idx, 1)
      this.$emit('change', this.pegawai)
    },
  },
}
</script>
